<template>
  <el-dialog
    :visible.sync="setDialogVisiable"
    class="set-tag-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="closeForm"
    title="试题属性"
    width="560px"
  >
    <div class="main">
      <div class="tag-item">
        <span class="label" style="margin-right: 12px;">题型</span>
        <el-select
          class="height32 width200"
          v-model="tagForm.questionTypeId"
          placeholder="请选择题型"
          clearable
          style="width: 305px;"
          @change="handleChange"
        >
          <el-option
            v-for="item in basicQuestionType"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span class="subffix" style="margin-left: 12px;">共{{ num }}题</span>
      </div>
      <div class="tag-item">
        <span class="label" style="margin-right: 12px;">题号</span>
        <el-input-number
          class="height32 width90"
          v-model="tagForm.start"
          :controls="false"
          :min="1"
        ></el-input-number>
        <span class="line">
          -
        </span>
        <el-input-number
          class="height32 width90"
          v-model="tagForm.end"
          :controls="false"
          :min="1"
        ></el-input-number>
      </div>
    </div>
    <div class="btn-list">
      <div
        class="close-btn"
        @click="closeForm"
      >
        关闭
      </div>
      <div
        class="submit-btn"
        @click="submitForm"
      >
        提交
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { isEmpty } from '@/utils/tools'

export default {
  name: "set-tag-dialog",
  data() {
    return {
      loading: false,
      num: 0,
      curQuestionNumber: [],
      tagForm: {
        questionTypeId: "",
        start: "",
        end: "",
      },
      htmlStr: '',
      splitApp: null,
      splitObj: {}
    };
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
    tagInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    async setDialogVisiable(newValue, oldValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.curQuestionNumber = []
          this.tagForm.questionTypeId = ''
          this.num = 0
          if (this.tagInfo.curQuestionList) {
            this.tagInfo.curQuestionList.forEach(element => {
              if (element.orderNumber && !this.curQuestionNumber.includes(element.orderNumber)) {
                this.curQuestionNumber.push(element.orderNumber)
              }
              if (element.children && element.children.length > 0) {
                element.children.forEach(cElement => {
                  if (cElement.orderNumber && !this.curQuestionNumber.includes(cElement.orderNumber)) {
                    this.curQuestionNumber.push(cElement.orderNumber)
                  }
                })
              }
            });
            this.tagForm.start = ""
            this.tagForm.end = ""
          }
          this.splitApp = this.tagInfo.splitApp || null
          this.htmlStr = this.tagInfo.htmlStr || ''
          console.log(this.tagInfo.insertIndex);
          // this.tagForm.start = this.tagInfo.insertIndex
          // this.tagForm.end = this.tagForm.start + this.num - 1
        })
      }
    },
  },
  mounted() {},
  computed: {
    ...mapState({
      // 不要m选n
      basicQuestionType(state) {
        if (!state.basicDataV3.basicQuestionType) {
          return []
        }
        return state.basicDataV3.basicQuestionType.filter(item => {
          return !isEmpty(item.structureTypeId) && item.structureTypeId !== 6
        })
      },
    }),
    setDialogVisiable: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    handleChange() {
      console.log(this.htmlStr);
      // 选择题型拆解
      let splitObj = this.splitApp.setHtmlStr(this.htmlStr).startSplit(this.tagForm.questionTypeId);
      if (!splitObj || splitObj.outputList.length === 0) {
        this.$message.error("未识别到该题型，请按规范重新划题识别！");
        return;
      }
      this.splitObj = splitObj
      if (splitObj.outputList) {
        let num = 0;
        splitObj.outputList.forEach(element => {
          if (element.structId !== 4 && element.children.length > 0) {
            num += element.children.length
          }
          else {
            num += 1
          }
        })
        this.num = num
      }
    },
    closeForm() {
      this.setDialogVisiable = false;
    },
    submitForm() {
      if (this.loading) {
        return
      }
      this.loading = true
      if (!this.tagForm.questionTypeId) {
        this.$message.warning("请选择题型");
        this.loading = false
        return
      }
      if (!this.tagForm.start || !this.tagForm.end) {
        this.$message.warning("请输入题号");
        this.loading = false
        return
      }
      if (this.tagForm.start > this.tagForm.end) {
        this.$message.warning("开始题号大于结束题号");
        this.loading = false
        return
      }
      let gap = this.tagForm.end - this.tagForm.start
      if (this.num > gap + 1) {
        this.$message.warning("尚有未标注题号的题目");
        this.loading = false
        return
      }
      if (this.num < gap + 1) {
        this.$message.warning("题号大于题目数");
        this.loading = false
        return
      }
      let hasOverlap = false
      for (let num of this.curQuestionNumber) {
        // 检查当前元素是否在区间 [start, end] 内
        if (num >= this.tagForm.start && num <= this.tagForm.end) {
          hasOverlap = true; // 如果有元素在区间内，返回 true
          break
        }
      }
      if (hasOverlap) {
        this.$message.warning("存在重复题号");
        this.loading = false
        return
      }
      this.$emit('setTag', {
        ...this.tagForm,
        splitObj: this.splitObj
      });
      this.setDialogVisiable = false;
      this.loading = false
    }
  },
};
</script>
<style lang='scss'>
.set-tag-dialog {
  .el-dialog {
    border-radius: 4px;
  }

  .el-dialog__header {
    font-weight: bold;
    font-size: 16px;
    color: #1d2129;
    line-height: 24px;
    padding: 16px;
    border: 1px solid #e5e6eb;
    border-radius: 4px 4px 0 0;

    .title {
      font-size: 16px;
      font-style: normal;
      color: #1d2129;
      line-height: 24px;

      em {
        font-weight: normal;
        font-style: normal;
        font-size: 14px;
        line-height: 24px;
        color: #4e5969;
      }
    }
  }
  .el-dialog__body {
    padding: 0 16px 16px 16px;
    border-radius: 0 0 4px 4px;

    .main {
      padding-top: 32px;

      .tag-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 24px;
        margin-left: 116px;

        span.label {
          font-size: 14px;
          color: #1D2129;
          text-align: right;
          line-height: 22px;
        }

        span.line {
          display: block;
          width: 20px;
          text-align: center;
        }
      }
    }

    .btn-list {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 32px auto 0 auto;
    }

    .close-btn {
      width: 88px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      color: #0fa784;
      background: #fff;
      border: 1px solid #0fa784;
      border-radius: 2px;
      cursor: pointer;
      box-sizing: border-box;
      margin-right: 16px;
    }

    .submit-btn {
      width: 88px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background: #0fa784;
      border-radius: 2px;
      cursor: pointer;
      box-sizing: border-box;
    }
  }

  .height32 {
    height: 32px;
    line-height: 32px;

    .el-input__inner {
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
    }

    .el-input__icon {
      line-height: 32px;
    }
  }

  .width90 {
    width: 90px;
  }
  .el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #0EA980;
  }
  .el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
    border-color: #0EA980;
  }
  .el-select-dropdown__item.selected {
    color: #0EA980;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/htmlSplit/components/setTagDialog.vue